import { WORKER_URL } from "./constants";

export async function fetchNewsFromWorker() {
  try {
    const res = await fetch(`${WORKER_URL}/articles`);
    if (res.ok) {
      const data = await res.json();
      if (data.ok && data.articles?.length > 0)
        return { articles: data.articles, lastUpdated: data.lastUpdated || null, themes: data.themes || [] };
    }
  } catch {}
  const res = await fetch(`${WORKER_URL}/news`);
  if (!res.ok) throw new Error(`Worker error ${res.status}`);
  const data = await res.json();
  if (!data.ok) throw new Error(data.error || "News fetch failed");
  return { articles: data.articles || [], lastUpdated: data.lastUpdated || null, themes: [] };
}

export async function postOverride(article, direction, TIER_UP, TIER_DOWN) {
  const newCls = direction === "up" ? TIER_UP[article.cls] : TIER_DOWN[article.cls];
  if (!newCls) return null;
  try {
    await fetch(`${WORKER_URL}/override`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({
        articleId: article.id,
        direction,
        headline: article.hed,
        originalCls: article.cls,
        overrideCls: newCls,
      }),
    });
  } catch {}
  return newCls;
}

export async function callGemini(keys, model, prompt) {
  for (let attempt = 0; attempt < 3; attempt++) {
    if (attempt > 0) await new Promise(r => setTimeout(r, 5000 * attempt));
    const res = await fetch(`${WORKER_URL}/gemini`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ model, prompt }),
    });
    if (res.status === 429 || res.status === 503) continue;
    if (!res.ok) { const e = await res.json().catch(() => ({})); throw new Error(e?.error || `Worker ${res.status}`); }
    const data = await res.json();
    return data.text || "";
  }
  throw new Error("quota_429");
}

export async function fetchDeepAnalysis() {
  try {
    const workerRes = await fetch(`${WORKER_URL}/deep`);
    if (workerRes.ok) {
      const workerData = await workerRes.json();
      if (workerData.ok && (workerData.ach?.length > 0 || workerData.scenarios?.length > 0)) {
        return { ach: workerData.ach || [], cuiBono: workerData.cuiBono || "", scenarios: workerData.scenarios || [], topArticles: workerData.topArticles || [], adversaryFrame: workerData.adversaryFrame || null, themes: workerData.themes || [] };
      }
    }
  } catch {}
  return null;
}

export async function fetchSubScenarios(scenario, topArticles) {
  const res = await fetch(`${WORKER_URL}/sub-scenarios`, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({ scenario, topArticles }),
  });
  if (!res.ok) throw new Error(`Worker ${res.status}`);
  const data = await res.json();
  if (!data.ok) throw new Error(data.error || "sub-scenarios failed");
  return data.subs;
}

export async function generateCustomIdeas(hypothesis, mode = "fresh") {
  const res = await fetch(`${WORKER_URL}/idea/custom`, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({ hypothesis, mode }),
  });
  const data = await res.json().catch(() => ({}));
  if (res.status === 429) {
    if (data.error === "daily_cap") {
      const err = new Error("daily_cap");
      err.code = "daily_cap";
      err.limit = data.limit;
      throw err;
    }
    const err = new Error("rate_limit");
    err.code = "rate_limit";
    throw err;
  }
  if (!res.ok || !data.ok) throw new Error(data.error || `Worker ${res.status}`);
  return { ideas: data.ideas, remaining: data.remaining };
}

export async function fetchAutoIdeas() {
  try {
    const workerRes = await fetch(`${WORKER_URL}/idea`);
    if (workerRes.ok) {
      const workerData = await workerRes.json();
      if (workerData.ok && workerData.ideas?.length > 0) {
        return workerData.ideas;
      }
    }
  } catch {}
  return null;
}
